import React from "react";
import { useNavigate } from "react-router-dom";
import { FileText } from "lucide-react";
import "./NavigationButtons.css";

const MyContentButton = ({ title = "My Content", disabled = false }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    navigate("/userfolders");
  };

  return (
    <button
      className="nav-button nav-button-mycontent"
      onClick={disabled ? undefined : handleClick}
      title={title}
      disabled={disabled}
    >
      <FileText size={18} strokeWidth={2} />
    </button>
  );
};

export default MyContentButton;
